import { IField } from '@/document-edit/assembler/fields/types/field';
import { IDocumentPage } from '@lib-shared/types/document-page';

export class PageHelper {
  static getPagesWithFields(pages: IDocumentPage[], fields: IField[]): IDocumentPage[] {
    return pages.map((page: IDocumentPage) =>
      fields.some((field: IField) => field.pageId === page.id)
        ? { ...page, fields: fields.filter((field: IField) => field.pageId === page.id) }
        : page
    );
  }
}
